module.exports = __webpack_public_path__ + "static/media/choithramsLogo.351b41f3.svg";